// Func = limiting Scope for this file
(function(){

	function resizeWindow(){

	}


	function scrollLeft(){
		let left = $(document).scrollLeft();
		if (left > $('header .container').outerWidth() + 100) {
			$('header').addClass('scroll-left');
		} else {
			$('header').removeClass('scroll-left');
		}
	}

	//$.fn.isInHorizontalView = function(){
	//	var elementLeft = $(this).offset.left;
	//	var elementRight = elementLeft + $(this).outerWidth();
    //
	//	var viewportLeft = $(window).scrollLeft();
	//	var viewportRight = viewportLeft + $(window).width();
    //
	//	return elementRight > viewportLeft && elementLeft < viewportRight;
	//};

	//function toggleDecadeVisibility() {
	//	var windowWidth = $(window).width();
    //
	//	$('.timeline-item').each(function() {
	//		var elementLeft = $(this).offset().left,
	//			visibleOffset = (windowWidth / 2) - ($(this).width() / 2),
	//			hideOffset = visibleOffset - $(this).width();
    //
	//		// If element is in center of viewport, make visible
	//		if (elementLeft <= visibleOffset && elementLeft >= hideOffset) {
	//			$(this).addClass('element-visible');
	//		} else {
	//			$(this).removeClass('element-visible');
	//		}
	//	});
	//}

	//animations below
	const animateHTML = function () {
		let elems,
			windowHeight;
		let init = function () {
			elems = document.getElementsByClassName('hide-object');
			windowHeight = window.innerHeight;
			addEventHandlers();
		};
		let addEventHandlers = function () {
			window.addEventListener('scroll', checkPosition);
			window.addEventListener('resize', init);
		};
		let checkPosition = function () {
			for (let i = 0; i < elems.length; i++) {
				let posFromTop = elems[i].getBoundingClientRect().top;
				if (posFromTop - windowHeight <= 0) {
					elems[i].className = elems[i].className.replace('hide-object', 'show-object')
				}
			}
		};
		return {
			init: init
		}
	};
	animateHTML().init();
	//end animations

	//nav hide on scroll
    var lastScrollTop = 0;

    function resizeWindow(){
        if($(window).width() > 767) {
            setTimeout(function() {
				if (typeof equalize !== 'undefined' && typeof equalize === 'function'){
					equalize();
				}
            }, 400);
            if($('#case .unit').length > 0 || $('.cs-grid .unit').length > 0) {
                $('#case .unit, .cs-grid .unit').css('height',$('#case .unit, .cs-grid .unit').width());
            }
        }
    }

    window.onload = function(){
        scrollW();
        window.addEventListener('scroll', function(){
            scrollW();
        })
    }
    function scrollW(){
        let st = window.pageYOffset || document.documentElement.scrollTop;
        if(st > 80){
            if (st > lastScrollTop){
                // downscroll code
                if(!document.getElementById('header').classList.contains('down')){
                    document.getElementById('header').classList.add('down');
                    document.getElementById('header').classList.remove('up');
                }
            } else {
                // upscroll code
                if(!document.getElementById('header').classList.contains('up')){
                    document.getElementById('header').classList.add('up');
                    document.getElementById('header').classList.remove('down');
                }
            }
        } else {
            if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
                document.getElementById('header').classList.remove('up');
                document.getElementById('header').classList.remove('down');
            }
        }
        lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }
	//end nav script

	$(document).ready(function () {

		//Call function with browser is resized.
		$(window).resize(function (event) {
			resizeWindow();
		});
		resizeWindow();

        //let totalWidth = 0;

        $('.timeline__each-item').each(function(index) {
            totalWidth += parseInt($(this).width(), 50);
        });

        let totalWidth =  $('.history-body').width();

        console.log(totalWidth);

        //$('.history-body').css( 'width', totalWidth + $(window).width());

		//Acts when scroll down page.
		$(window).scroll(function (event) {
			scrollLeft();

			// toggleDecadeVisibility();

			// if($('.timeline-item').isInHorizontalView()) {
			// 	$(this).addClass('huzzah');
			// }
		});

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.sub-menu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.sub-menu',this).fadeOut(200);
		});

		//Primary Nav subnav dropdown
		$('#menu-btn').click(function(){
			$(this).toggleClass('open');
			$('#header-subnav').slideToggle();
			$('.menu-btn__default').fadeToggle();
			$('.menu-btn__close').fadeToggle();
		});


		//Home Scroll Trigger
		$('.hero__scroll-trigger').click(function(){
			$([document.documentElement, document.body]).animate({
				scrollTop: $(".intro").offset().top - 183
			}, 1500);
		});

		//Force Weddings LP GDPR subscribe to be required
		$('input[name=subscribe]').addClass('required');

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";
		$( "#CheckIn" ).datepicker({
				//showOn: "both",
				//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
				//buttonImageOnly: true,
				changeMonth: true,
				dateFormat: DATE_FORMAT,
				numberOfMonths: 1,
				//minDate: "20-08-24",
				beforeShowDay: (date) => calendarRange(date),
				onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
				//showOn: "both",
				//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
				//buttonImageOnly: true,
				dateFormat: DATE_FORMAT,
				changeMonth: true,
				numberOfMonths: 1,
				beforeShowDay: (date) => calendarRange(date),
				onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		$(".specials-filter #window-view").on('change',function (e) {
			e.preventDefault();
			var filterArea = $(this).closest(".filter").attr("data-filter-section");
			var filterby = $(this).val();
			if (filterby == "see-all") {
				$(".filter-block").show();
				$(".filter-block .animate-fade").addClass("fade-in visible");
			} else {
				var selectedBlocks = $("#" + filterArea).children(
				".filter-block[data-filter*='" + filterby + "']"
				);
				$("#" + filterArea)
				.children(".filter-block[data-filter*='" + filterby + "']")
				.remove();
				$(".filter-block").hide();
				$(selectedBlocks).prependTo("#" + filterArea);
				$("#" + filterArea)
				.children(".filter-block[data-filter*='" + filterby + "']")
				.show();
				$("#" + filterArea)
				.children(".filter-block[data-filter*='" + filterby + "']")
				.find(".animate-fade")
				.addClass("fade-in visible");
			}
			$(".filter-block .sym-slides").slick("unslick");
			$(".filter-block .sym-slides").slick({
				accessibility: false,
			});
		});
	
	});

	// $(window).on('load', function() {});

}());